import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import MaterialReactTable from 'material-react-table';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { MultiSelect } from "react-multi-select-component";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
const CompanyLogin = () => {

    const navigate = useNavigate();
    const { statelocation } = useLocation();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionCompany, setOptionCompany] = useState([]);
    const [companyValue, setCompanyValue] = useState([]);
    const [selected, setSelected] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [formsData, setFormsData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [emailValue, setEmailValue] = useState("");
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [mobileValue, setMobileValue] = useState("");
    const [userNameValue, setUserNameValue] = useState("");
    const [gender, setGender] = useState('');
    const [selectedDataSet, setselectedDataSet] = useState('');
    const [selectedUserType, setSelectedUserType] = useState([]);
    const [showDiv, setShowDiv] = useState(false);
    const [optionDesignaion, setOptionDesignation] = useState([]);
    const [designationValue, setDesignationValue] = useState([]);
    const [loader, setLoader] = useState(false);
    //const [orgType, setOrgType]=useState("")

    useEffect(() => {


     
        getCompany();
        fetchDesignation();

    }, []);


    const fetchDesignation = async () => {
        const result = await axios(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Management/commDesignation`
        );

        setOptionDesignation(result.data.dataContent);
    };
    const usertype = [
        { label: "Company Admin", value: "C" },
        { label: "State Admin", value: "G" },
        { label: "MNCFC Admin", value: "M" }

    ];
    useEffect(() => {
      
        if (isFetchingState == false) {
            console.log("setIsFetchingState !!!!", isFetchingState);
            handleState();
            setIsFetchingState(true);
        }
      

    }, [stateValue]);

    function handleResetForm() {
        setEmailValue("");
    }
    let handleCompany = (companyValue) => {
       
        if (companyValue.length > 1) {
            alert('Please select one value');
            return false;
        }
        else {
            console.log("selected Company", companyValue);
            setCompanyValue(companyValue.map(option => option.value));
            
        }

    };
    let handleDesignation = (designationValue) => {

        setDesignationValue(designationValue);
    }

    function validateEmail() {
        if (emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            document.getElementById("emailid").style.borderColor = "green";
        } else {
            document.getElementById("emailid").style.borderColor = "red";

        }
    }

    function getStates(orgType) {

      
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            userCode: sessionStorage.getItem("userCodeModel"),
            stateCode: "",
            districtCode: "",
            subDistrictCode: "",
            villageCode: "",
            OrgTypeCode:orgType
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/gt/LGD_Location`,
            requestOptions
        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                console.log("localFormData", localFormDataState);
                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.stateName, value: item.stateCode })
                })
                console.log("myArray", myArray)
                setOptionState(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }
    function getCompany() {

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/gt/Company`
        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                console.log("localFormData", localFormDataState);
                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.companyName, value: item.companyCode })
                })
                console.log("myArray", myArray)
                setOptionCompany(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }

    let handleChange = (stateValue) => {
        console.log("selected State", stateValue);
        setIsFetchingState(false);
        setStateValue(stateValue.map(option => option.value));

    };

    function handleState() {
        setOptionDistrict([]);
        if (stateValue.length != 0) {
            console.log("handle State Data !!!", stateValue);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let statedata = "";
            let stateValueData = "";
            console.log("State Value Data", stateValue)
            stateValue.map((item) => {
                stateValueData = stateValueData + item + ","
            })

            stateValueData = stateValueData.slice(0, -1);
            var raw = JSON.stringify({
                userCode: sessionStorage.getItem("userCodeModel"),
                stateCode: stateValueData.toString(),
                districtCode: "",
                subDistrictCode: "",
                villageCode: ""
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/gt/LGD_Location`,
                requestOptions
            )


                .then((response) => response.text())
                .then((result) => {
                    let localFormDataDistrict = JSON.parse(result).dataContent;
                    console.log("localFormDataDistrict", localFormDataDistrict);
                    let myArrayDistrict = [];
                    localFormDataDistrict.map((item, key) => {
                        myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                    })
                    console.log("myArrayDistrict!!", myArrayDistrict)
                    setOptionDistrict(myArrayDistrict)
                    setIsFetching(false);
                })
                .catch((error) => console.log("error", error));
        }
    }

    let handleChangeDistrict = (districtValue) => {

        setDistrictValue(districtValue.map(option => option.value));

        setselectedDataSet(districtValue.map(item => `${item.stateid}|${item.value}`).join(','));
    };

   
    let handleUserType = (userTypeValue) => {
        console.log("selected User Type !!!!", userTypeValue);
        let userTypeValuecheck = userTypeValue.map(option => option.value);
       
        if (userTypeValuecheck == 'C') {
          
            setShowDiv('show');
            setStateValue('');
        }
        else {
          
            setShowDiv('hide');
            setStateValue('');
        }
        if (userTypeValuecheck != '') {
           
        getStates(userTypeValuecheck.toString());
        }
        else
        {
            setStateValue('');
        }

        if (userTypeValue.length > 1) {
            alert('Please select one value');
            return false;
        }
        else {
            setSelectedUserType(userTypeValue.map(option => option.value));
        }

    };

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {
        // setMobileVerify(false)
        if (mobileValue.length === 10) {
            document.getElementById("mobilenumber").style.borderColor = "green";

        } else {
            document.getElementById("mobilenumber").style.borderColor = "red";

        }
    }

    function ValidateAddUser() {
 
        let valid = false;

        if (selectedUserType === "C") {
            if (companyValue === "" || companyValue === "Select..." || companyValue.length === 0) {
                valid = false;
                alert("Select Any Company Value")

                return;
            } else {
                valid = true
            }
        }
        if (selectedUserType === "" || selectedUserType === "Select..." || selectedUserType.length === 0) {
            valid = false;
            alert("Select Any User Type Value")

            return;
        } else {
            valid = true
        }


        if (stateValue.length === 0) {
            alert("Select Any State Value")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (userNameValue === "") {
            valid = false;
            alert("Enter Correct User Name")
            return;
        } else {
            valid = true
        }

        if (gender === "") {
            valid = false;
            alert("Select Gender")
            return;
        } else {
            valid = true
        }
        if (mobileValue === "") {
            valid = false;
            alert("Enter Mobile Number")
            return;
        } else if (mobileValue.length !== 10) {
            valid = valid = true;
            alert("Enter 10 digit Mobile Number")
            return;
        }
        else {
            valid = true
        }

        if (designationValue.length === 0) {
            valid = false;
            alert("Select Designation")
            return;
        } else {

            valid = true


        }

        let matchval = emailValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);

        if (emailValue === "") {
            valid = false;
            alert("Enter Email")
            return;
        } else if (matchval === null) {
            valid = false;
            alert("Enter Correct Email")
            return;
        }

        else {
            valid = true
        }



        if (valid === true) {
            AddNewUser();
        }



    }
    function AddNewUser() {

       
        setLoader(true)

        let stateValueData = "";
        let districtValueData = "";
        console.log("State Value Data", stateValue)
        console.log("selected District Add", districtValue);
        console.log("Selected User Type", selectedUserType);

        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSet != "") {
            districtValueData = selectedDataSet;
        }


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "userRoleCode": "1",
            "userName": userNameValue.toString(),
            "userId": mobileValue.toString(),
            "mobile": mobileValue.toString(),
            "emailId": emailValue.toString(),
            "gender": gender.toString(),
            "departmentCode": sessionStorage.getItem("departmentNameModel"),
            "designationCode": designationValue.toString(),
            "stateCode": stateValueData.toString(),
            "districtCode": districtValueData.toString(), //Number(userLevelValue) > 2 &&  districtValue !== "NA" && districtValue !== "" && districtValue !== "Choose..." ? String(districtValue) : "",
            "subDistrictCode": "",// Number(userLevelValue) > 3 && subDistrictValue !== "NA" && subDistrictValue !== "" && subDistrictValue !== "Choose..." ? String(subDistrictValue) : "",
            "blockCode": "",
            "villageCode": "",// Number(userLevelValue) > 4 ? String(localVillageValue) : "",
            "userTypeCode": "2",
            "schemeCode": sessionStorage.getItem("schemeCodeModel").toString(),
            "Aadhar": "",
            "orgTypeCode": selectedUserType.toString(),
            "InsuranceCompanyCode": companyValue.toString(),
            "isMobileVerified": "N",
            "isEmailVerified": "N"
        });
        console.log("rawdata", raw);
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/gt/users`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    setLoader(false);
                    navigate("/newadminpanel/userlist");
                }
                else
                {
                    setLoader(false);
                }
            })
            .catch((error) => console.log("error", error));

    }
    function UpdateUser() {
    }

    function handleUserName(e) {
        let localText = e.target.value.replace(/[^\w\s]/gi, "")
        setUserNameValue(localText)
    }


    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'Surveyor User Name',
                header: 'Surveyor User Name',
            },
            {
                accessorKey: 'State',
                header: 'State',
            },
            {
                accessorKey: 'District',
                header: 'District',
            },
            {
                accessorKey: 'Sub-District',
                header: 'Sub-District',
            },
            {
                accessorKey: 'Mobile Number',
                header: 'Mobile Number',
            },
            {
                accessorKey: 'Father Name',
                header: 'Father Name',
            },
            {
                accessorKey: 'Aadhar Number',
                header: 'Aadhar Number',
            },
            {
                accessorKey: 'Gender',
                header: 'Gender',
            },

        ],
        [],
    );

    return (

        <>
            <AdminHeaderNew />
            <AdminSideBarNew />

            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Users Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">User Creation</li>
                        </ol>
                    </nav>

                </div>
                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <form className="row g-3">
                                        <div className="col-md-3">
                                            <label className="form-label">User Type</label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={usertype}
                                                onChange={handleUserType}
                                                value={usertype.filter(option => selectedUserType.includes(option.value))}
                                                labelledBy="Select"
                                            />

                                        </div>

                                        {showDiv === 'show' && (<div className="col-md-3" id="companyDiv">
                                            <label htmlFor="Company" className="form-label">
                                                Company
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionCompany}
                                                onChange={handleCompany}
                                                value={optionCompany.filter(option => companyValue.includes(option.value))}
                                                labelledBy="Select" />
                                        </div>)}
                                        <div className="col-md-3">
                                            <label className="form-label">Name</label><label style={{ color: "red" }}>*</label>
                                            <input placeholder='User Name' type='text' className='form-control' onChange={(e) => handleUserName(e)} value={userNameValue} maxLength={50} readOnly={statelocation ? true : false} />
                                        </div>

                                        <div className="col-md-3">
                                            <label htmlFor="mobileNo" className="form-label">
                                                Mobile No.
                                            </label><label style={{ color: "red" }}>*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="mobilenumber"
                                                required
                                                placeholder="Mobile No."
                                                onChange={(e) => handleMobileNumber(e.target.value)}
                                                value={mobileValue}
                                                onKeyUp={validateMobile}
                                                maxLength="10"
                                                readOnly={statelocation ? true : false}

                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Email Id:</label><label style={{ color: "red" }}>*</label>
                                            <input placeholder='Email Id' type='text' id="emailid" className='form-control' onChange={(e) => setEmailValue(e.target.value)} value={emailValue} onKeyUp={validateEmail}
                                                maxLength={50} readOnly={statelocation ? true : false} />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Gender :</label><label style={{ color: "red" }}>*</label>
                                            <div className="col-md-12">


                                                <div
                                                    className="form-check form-check-inline"
                                                    onClick={() => {
                                                        setGender("M");
                                                    }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="inlineRadio1"
                                                        value="male"
                                                        checked={gender === "M" ? "true" : ""}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="inlineRadio1"
                                                    >
                                                        Male
                                                    </label>
                                                </div>
                                                <div
                                                    className="form-check form-check-inline"
                                                    onClick={() => {
                                                        setGender("F");
                                                    }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="inlineRadio2"
                                                        value="female"
                                                        checked={gender === "F" ? "true" : ""}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="inlineRadio2"
                                                    >
                                                        Female
                                                    </label>
                                                </div>
                                                <div
                                                    className="form-check form-check-inline"
                                                    onClick={() => {
                                                        setGender("T");
                                                    }}
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="inlineRadio3"
                                                        value="transgender"
                                                        checked={gender === "T" ? "true" : ""}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="inlineRadio3"
                                                    >
                                                        Transgender
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="State" className="form-label">
                                                State
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionState}
                                                value={optionState.filter(option => stateValue.includes(option.value))}
                                                // value={selected}
                                                onChange={handleChange}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                defaultValue={stateValue} disabled={statelocation ? true : false} />
                                        </div>
                                        <div className="col-md-3" style={{ display: "none" }}>
                                            <label htmlFor="District" className="form-label">
                                                District
                                            </label><label style={{ color: "red" }}>*</label>
                                            <MultiSelect
                                                options={optionDistrict}
                                                value={optionDistrict.filter(option => districtValue.includes(option.value))}
                                                // value={selected}
                                                onChange={handleChangeDistrict}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                defaultValue={districtValue} disabled={statelocation ? true : false} />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="Designation" className="form-label">
                                                Designation
                                            </label><label style={{ color: "red" }}>*</label>
                                            <select
                                                id="userDesignation"
                                                required
                                                className="form-select"
                                                onChange={(e) => handleDesignation(e.target.value)}
                                                value={designationValue}
                                                name="userDesignation"

                                            >
                                                <option value="NA">Choose...</option>
                                                {optionDesignaion ? optionDesignaion.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.desigCode}>
                                                            {" "}
                                                            {item.desigName}
                                                        </option>
                                                    );
                                                }) : ""}
                                            </select>

                                        </div>

                                        <div className="col-md-12 d-flex justify-content-md-center">

                                            <button type="button" className="btn btn-primary me-md-2" onClick={ValidateAddUser} >Submit</button>
                                            <button type="button" className="btn btn-primary me-md-2" onClick={() => navigate("/newadminpanel/userlist")}>Cancel</button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>


                    </div>
                </section>

            </main>

            <AdminFooterNew />
            {loader === false ? "" : <div class="overlay">
                <div class="overlay__inner">
                    <div class="overlay__content"><span class="spinner"></span></div>
                </div>
            </div>}
        </>
    );
}
export default CompanyLogin